import React from 'react'
import TabLinkUI from '../../../widgets/output/TabLinkUI'
import NameAndEditUI from '../../../widgets/layout/NameAndEditUI.js'
import LabelAndValueUI from '../../../widgets/layout/LabelAndValueUI'
import OrderUpdateModalSF from './OrderUpdateModalSF'
// import './OrderHeader.css'

const OrderHeaderUI = ({context, messageList, order,
  onUpdateClick, updateMode, onCancelClick, onUpdateComplete
}) =>
  <div className='ord_hdr'>
    <div className='g_flex_h'>
      <div>
        <div className='g_small'>{order.customerName}</div>
        {
          onUpdateClick &&
          <NameAndEditUI name={order.estimateName} onUpdateClick={onUpdateClick} />
        }
        {
          ! onUpdateClick &&
          <span>{order.estimateName}</span>
        }
      </div>
      <LabelAndValueUI messageList={messageList} labelKey='c_order_date' align='right'>
        <span>{order.orderDateF1}</span>
      </LabelAndValueUI>
    </div>
    <div className='g_m_top_100'>
      <TabLinkUI messageList={messageList} labelKey='c_items'
        active={window.location.pathname.includes('/items')}
        to={`/orders/${order.id}/items`}
      />
      <TabLinkUI messageList={messageList} labelKey='c_budgets'
        active={window.location.pathname.includes('/budgets')}
        to={`/orders/${order.id}/budgets`}
      />
      <TabLinkUI messageList={messageList} labelKey='c_invoices'
        active={window.location.pathname.includes('/invoices')}
        to={`/orders/${order.id}/invoices`}
      />
    </div>

    <OrderUpdateModalSF context={context} order={order}
      updateMode={updateMode} onCancelClick={onCancelClick} onUpdateComplete={onUpdateComplete}
    />
  </div>

export default OrderHeaderUI
